import React from 'react';
import { Status } from '../reservations/status/component';
import { ICompanyBooking } from '../../../share/common-types/company-bookings';
import { FormattedMessage } from 'react-intl';

import './style.scss';

interface IProps {
  refundability: string;
}

interface IPriceProps {
  record: ICompanyBooking;
}

export class ReservationRefundability extends React.Component<IProps> {
  getText = (): string => {
    const { refundability } = this.props;
    const map: any = {
      ['false']: 'non-refundable',
      ['true']: 'refundable',
    };
  
    return `bookings.booking.status.${map[refundability]}`;
  };

  getClass = (): string => {
    const { refundability } = this.props;
    const map: any = {
      ['false']: 'non-refundable',
      ['true']: 'refundable',
    };

    return map[refundability];
  };

  render(): React.ReactNode {
    if (this.props.refundability) {
      return <Status
        text={this.getText()}
        className={this.getClass()} />;
    }

    return null;
  }
}

export class CompanyBookingPrice extends React.Component<IPriceProps> {
  getText = (): string => {
    const { record } = this.props;
    const map: any = {
      ['Refundable']: 'refundable',
      ['Non-refundable']: 'non-refundable',
      ['Non-Refundable']: 'non-refundable',
    };
  
    return `bookings.booking.status.${map[record?.refundability.toString()] || 'non-refundable'}`;
  };

  render(): React.ReactNode { //<Currency currency={currency} />{renderNumber(totalAmount, 2)}
    return (<div className="price-col"><div>{Number(this.props.record?.totalPaid)?.toFixed(2)}</div><div className="refundable-col">{<FormattedMessage id={this.getText()} />}</div></div>);
  }
}